<template>
  <td class="table-security-cell" :class="security">
    <template v-if="canEdit">
      <ux-button size="sm" :loading="processing" @click.stop.prevent="clicked">
        <ux-icon :icon="public ? `fa-lock-open` : `fa-lock`" />
      </ux-button>
    </template>
    <template v-else>
      <ux-icon :icon="public ? `fa-lock-open` : `fa-lock`" />
    </template>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  methods: {
    async clicked() {
      const self = this;
      const id = self.$sdk.utils.id(self.row);
      const security = self.public ? "secure" : "public";

      self.processing = true;
      try {
        await self.$sdk.content.patch(id, {
          meta: {
            security,
          },
        });
        // Update the row itself so the cell (and anything else bound
        // to this record) stays in sync with the single source of truth
        if (!self.row.meta) {
          self.row.meta = {};
        }
        self.row.meta.security = security;
        self.$sdk.notify(`Set security to ${security}`);
      } catch (err) {
        self.$sdk.error(err);
      } finally {
        self.processing = false;
      }
    },
  },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    canEdit() {
      var user = this.user;
      return this.$sdk.access.canEditItem(user, this.row);
    },
    public() {
      return this.security === "public";
    },
    security() {
      // Read straight from the reactive value (row.meta.security) so
      // external changes (e.g. bulk actions) reflect immediately
      return this.value || "secure";
    },
  },
};
</script>
<style scoped lang="scss">
td {
  text-align: center;

  &.public {
    opacity: 0.3;
  }

  &.true {
  }

  &.false {
    opacity: 0.3;
  }
}
</style>
